import type { IComponentController, IScope } from "angular";
import type { ISchedule, ISite } from "App/Modules/Models";
import { DayTypeFunctions } from "App/Modules/Models";
import type { Moment } from "moment-timezone";
import { utc } from "moment-timezone";
import { noop } from "lodash";

export default class TemporaryWeeklyScheduleComponentController implements IComponentController {
    public static $inject: string[] = ["$scope"];

    public schedule: ISchedule;

    public site: ISite;

    public groupTypeName: string;

    public dayTypes = DayTypeFunctions.WeekDaysMap();

    public addButtonDisabled = false;

    private datePeriodsWatch = noop;

    constructor(private readonly $scope: IScope) {}

    public $onInit() {
        this.datePeriodsWatch = this.$scope.$watch(
            "$ctrl.schedule.temporaryWeeklySchedule.datePeriods",
            (newVal: any[]) => {
                this.addButtonDisabled = !this.allDatesValid(newVal);
            },
            true,
        );

        if (!this.schedule.temporaryWeeklySchedule.datePeriods) {
            this.schedule.temporaryWeeklySchedule.datePeriods = [];
        }
    }

    public add() {
        this.schedule.temporaryWeeklySchedule.datePeriods.push({
            dateStart: null,
            dateStop: null,
        });
    }

    public deleteDatePeriod(datePeriod: any) {
        const index = this.schedule.temporaryWeeklySchedule.datePeriods.indexOf(datePeriod);

        this.schedule.temporaryWeeklySchedule.datePeriods.splice(index, 1);
    }

    public getToday(): Moment {
        return utc().tz(this.site.timeZone);
    }

    public isDeletable(datePeriod: any): boolean {
        return datePeriod.dateStart && datePeriod.dateStart.isSameOrBefore(this.getToday(), "day");
    }

    public checkShowUseScheduleExceptionHint(datePeriod: any) {
        return datePeriod && datePeriod.dateStop && datePeriod.dateStop.isSameOrAfter(this.getToday(), "day");
    }

    public noDatesConfigured() {
        return (
            !this.schedule.temporaryWeeklySchedule.datePeriods ||
            this.schedule.temporaryWeeklySchedule.datePeriods?.length === 0
        );
    }

    private allDatesValid(dates: any) {
        let invalidDateFound = false;
        dates?.some((datePeriod) => {
            if (!datePeriod.dateStart || !datePeriod.dateStop) {
                // one invalid period was found
                invalidDateFound = true;
            }
            // return true breaks the Array.some loop
            return invalidDateFound;
        });
        return !invalidDateFound;
    }
}
